<script>
import { fetchAreaList } from "@/api/url";
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      areaList: [],
      id: "",
    };
  },
  computed: {
    ...mapState({
      parking: (state) => state.parking.oneParking,
    }),
  },
  watch: {
    parking: {
      handler: function (val) {
        this.id = "";
        this.getAllAreaList(val);
      },
      deep: true,
      immediate: true,
    },
    id: {
      handler: function (val) {
        const currentArea = this.getCurrentArea(val);
        this.setArea(currentArea);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("parking", ["setArea"]),
    getAllAreaList(parking) {
      if (!parking) {
        this.areaList = [];
        return;
      }
      const params = { parkingId: parking.parkingId };
      this.$get(fetchAreaList(), params).then((data) => {
        if (data.status === 200) {
          this.areaList = data.data;
        }
      });
    },
    getCurrentArea(value) {
      const area = this.areaList.find((item) => value === item.areaId);
      if (area) {
        return {
          areaId: area.areaId,
          areaName: area.areaName,
        };
      }
      return null;
    },
  },
  render() {
    return (
      <el-select class="check-area" filterable clearable v-model={this.id}>
        {this.areaList.map((item) => (
          <el-option
            key={item.areaId}
            value={item.areaId}
            label={item.areaName}
          />
        ))}
      </el-select>
    );
  },
};
</script>
<style>
</style>